<template>
  <div>
    <filters-bar
    title-class="headline"
    :title="type"
    :filters="filters"
    :has-date-type="false"
    @search="setFilters">
      <template slot="content">
        <v-flex>
          <v-select
            v-model="type"
            :items="['Total','Historica']"
            label="Tipo de grafica"
            color="grey"
            class="w-auto d-inline-block"
            solo/>
        </v-flex>
      </template>
    </filters-bar>
    <v-layout row wrap pa-0 ma-0 justify-end>
      <p class="caption" v-if="date">
        Ultima actualización {{ date }}
      </p>
    </v-layout>
    <!-- <comparative v-show="graphicType === 'comparative'"></comparative> -->
    <total :filters="filters" v-show="type === 'Total'"></total>
    <historic :filters="filters" v-show="type === 'Historica'" />
    <!-- <detailed v-show="graphicType === 'detailed'"></detailed> -->
    <!-- <daily v-show="graphicType === 'daily'"></daily> -->
      <!-- <comparative-colektia-filters slot="content" v-show="graphicType === 'comparative' && type === 'Colektia'" :bus="comparativeBus"></comparative-colektia-filters> -->
      <!-- <comparative-company-filters slot="content" v-show="graphicType === 'comparative' && type === 'Company'"></comparative-company-filters> -->
      <!-- <daily-filters slot="content" v-show="graphicType === 'daily'"></daily-filters> -->
      <!-- <detailed-filters slot="content" v-show="graphicType === 'detailed'"></detailed-filters> -->
    </sidebar>
  </div>
</template>


<script>
import moment from 'moment';
// import Comparative from '@/components/panel/management/comparative/Index';
import Total from '@/components/panel/management/Total';
import Historic from '@/components/panel/management/Historic';
import FiltersBar from '@/components/global/FiltersBar';
// import Daily from '@/components/panel/management/Daily';
// import Detailed from '@/components/panel/management/Detailed';
// import ComparativeCompanyFilters from '@/components/panel/management/filters/Company';
import TotalFilters from '@/components/panel/management/filters/Total';
import HistoricFilters from '@/components/panel/management/filters/Historic';
// import DailyFilters from '@/components/panel/management/filters/Daily';
// import DetailedFilters from '@/components/panel/management/filters/Detailed';
import EventBus from '@/event-bus';

export default {
  props: ['date'],
  components: {
    // Comparative,
    Total,
    Historic,
    // Daily,
    // Detailed,
    FiltersBar,
    // ComparativeColektiaFilters: DailyFilters,
    // ComparativeCompanyFilters,
    TotalFilters,
    HistoricFilters,
    // DailyFilters,
    // DetailedFilters,
  },
  created() {
    EventBus.$on('openComparativeSidebar', (type) => {
      this.type = type;
      setTimeout(() => {
        EventBus.$emit('openSidebar');
      });
    });
    this.startListeningEvents();
  },
  destroyed() {
    this.stopListeningEvents();
  },
  data() {
    return {
      graphicType: 'totalGraphic',
      type: 'Total',
      filters: {
        date: moment().format('YYYY-MM-DD'),
        dateType: 'date',
        campaign: this.campaignFilter,
      },
      comparativeBus: {
        apply: 'applyComparativeColektiaFilters',
        filter: 'filterComparativeColektiaGraphic',
      },
    };
  },
  methods: {
    startListeningEvents() {
      window.Echo.channel('panelUpdate').listen('.PanelUpdate', () => {
        this.update();
      });
    },
    stopListeningEvents() {
      window.Echo.leave('panelUpdate');
    },
    setFilters(filters) {
      this.filters = {
        ...this.filters,
        ...filters,
      };
    },
    update() {
      if (this.graphicType !== 'comparative') {
        EventBus.$emit(this.sidebarBus.apply);
      } else {
        EventBus.$emit(this.sidebarBus.apply);
        EventBus.$emit(this.comparativeBus.apply);
      }
    },
  },
  watch: {
    type(value) {
      if (value === 'Total') {
        this.filters.dateType = 'date';
        EventBus.$emit('totalGraphicReload');
      } else if (value === 'Historica') {
        this.filters.dateType = 'month';
        EventBus.$emit('historicGraphicReload');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/panel/management/Index.vue